module.exports = __webpack_public_path__ + "static/media/Car Garage 4.13213314.svg";